import React from 'react';
import PropTypes from 'prop-types';

export const IconProviderMicrogamingBig = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="30"
    viewBox="0 0 120 30"
    fill="none"
  >
    <path
      d="M14.8299 0C6.63946 0 0 6.7156 0 15.0275C0 16.5138 0.217687 17.9725 0.653061 19.3761C0.92517 18.9908 1.19728 18.6055 1.44218 18.1927C2.47619 16.6514 3.48299 15.1101 4.4898 13.5413L5.22449 12.3578C5.46939 11.9725 5.71428 11.5596 5.93197 11.1743C6.42177 10.3761 6.88435 9.57798 7.31973 8.77982C7.53741 8.36697 7.7551 7.98165 8 7.56881C8.2449 7.15596 8.43537 6.77064 8.65306 6.3578C8.87075 5.94495 9.08843 5.53211 9.27891 5.14679L9.87755 3.90826L9.93197 3.82569C10.2585 3.16514 11.0476 2.88991 11.7279 3.19266C12.2177 3.46789 12.517 3.99083 12.4898 4.56881C12.4898 5.2844 12.3537 6.02752 12.2993 6.74312C12.2449 7.45872 12.2177 8.20183 12.1633 8.94495C12.1088 10.4037 12.0816 11.8899 12.0816 13.3486C12.0816 14.8073 12.1633 16.2661 12.2993 17.6697C12.381 18.3578 12.4898 19.0459 12.6258 19.7339C12.7347 20.3394 12.9252 20.945 13.1973 21.4954C13.2789 21.6606 13.3878 21.8257 13.5238 21.9633C13.6054 22.0184 13.551 21.9908 13.6054 21.9908C13.6599 21.9908 13.6327 21.9908 13.6599 21.9908L13.7143 21.9633H13.7415L13.8231 21.9358C13.8503 21.9083 13.9048 21.8807 13.932 21.8532C14.1497 21.6881 14.3401 21.4954 14.5306 21.2752C14.966 20.7523 15.3741 20.2294 15.7279 19.6514C16.1088 19.0734 16.4626 18.4404 16.8163 17.8073C17.5238 16.5413 18.1769 15.2477 18.8027 13.9266C19.102 13.2661 19.4286 12.6055 19.7279 11.9174C20.0272 11.2569 20.3265 10.5688 20.5986 9.90826C20.8707 9.22018 21.6599 8.88991 22.3401 9.16514C22.7755 9.33028 23.0748 9.7156 23.1565 10.1835C23.1565 10.3486 23.1837 10.5688 23.2109 10.789L23.2925 11.422C23.3469 11.8349 23.4014 12.2477 23.483 12.6606C23.619 13.4862 23.7823 14.3119 24 15.1101C24.2177 15.9083 24.4898 16.7064 24.8163 17.4771C25.1429 18.2477 25.551 18.9633 26.068 19.6239C26.1769 19.789 26.1497 20.0092 26.0136 20.1193C25.8775 20.2294 25.6871 20.2294 25.5782 20.1193C24.898 19.5138 24.2993 18.8257 23.7823 18.0826C23.2653 17.3394 22.8299 16.5413 22.4218 15.7431C22.1497 15.1927 21.932 14.6422 21.6871 14.0917C21.5238 14.422 21.3878 14.7523 21.2245 15.055C20.5714 16.4037 19.9184 17.7523 19.1565 19.1009C18.7755 19.8165 18.3946 20.4771 17.9592 21.1376C17.5238 21.8257 17.034 22.4862 16.517 23.0917C16.2177 23.4495 15.8639 23.7523 15.5102 24.055C15.4014 24.1376 15.2925 24.2202 15.1565 24.2752L14.9116 24.4128L14.7755 24.4679H14.7483L14.6667 24.4954H14.6122L14.5034 24.5229C14.4218 24.5505 14.3673 24.578 14.2857 24.578C14.1224 24.6055 13.9592 24.633 13.7959 24.6606C13.4422 24.6881 13.0612 24.633 12.7347 24.5229C12.4082 24.4128 12.1088 24.2202 11.8367 24C11.4286 23.6422 11.0748 23.2018 10.8299 22.7064C10.449 21.9358 10.1769 21.1101 10.0136 20.2569C9.85034 19.4862 9.7415 18.6881 9.65986 17.9174C9.4966 16.3761 9.44218 14.8624 9.41496 13.3211C9.41496 12.6055 9.41496 11.8624 9.41496 11.1468C9.14286 11.6697 8.87075 12.1927 8.59864 12.6881C8.38095 13.1009 8.16327 13.5138 7.91837 13.9266L7.23809 15.1651C6.31292 16.8165 5.36054 18.4404 4.35374 20.0642C3.72789 21.1101 3.07483 22.156 2.42177 23.1743C6.91156 30.1101 16.1088 32.0367 22.966 27.4954C29.8231 22.9541 31.7279 13.6514 27.2381 6.7156C24.4898 2.55963 19.8367 0 14.8299 0Z"
      fill="url(#microgaming-big-rule-1)"
    />
    <path
      d="M42.5034 20.422V10.4587H42.2585L39.1021 20.4495H38.313L35.1565 10.4587H34.9116V20.422H33.6055V9.41284H35.9184L38.7211 18.1651L41.4694 9.41284H43.8096V20.4495H42.5034V20.422Z"
      fill="url(#microgaming-big-rule-2)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.7142 9.41284V10.844H47.1292V9.41284H45.7142ZM45.7414 11.9174V20.422H47.1291V11.9174H45.7414Z"
      fill="url(#microgaming-big-rule-3)"
    />
    <path
      d="M55.5374 17.6422C55.5374 19.2936 54.9115 20.5597 52.1905 20.5597C48.7619 20.5597 48.5714 18.578 48.5714 16.156C48.5714 13.734 48.7619 11.7523 52.1905 11.7523C54.9115 11.7523 55.5374 13.0184 55.5374 14.6698H54.2313C54.2313 13.3211 53.7687 12.6606 52.1905 12.6606C50.068 12.6606 49.9592 13.8165 49.9592 16.1285C49.9592 18.4404 50.068 19.5964 52.1905 19.5964C53.7687 19.5964 54.2313 18.9358 54.2313 17.5872L55.5374 17.6422Z"
      fill="url(#microgaming-big-rule-4)"
    />
    <path
      d="M58.2313 12.8257C58.8844 12.4128 59.7279 11.8624 60.517 11.8348C60.6803 11.8073 60.8435 11.8073 61.0068 11.8073C61.2245 11.8073 61.415 11.8073 61.6599 11.8348L61.551 12.8532C61.3333 12.8257 61.1429 12.8257 60.9524 12.8257C60.7891 12.8257 60.6259 12.8257 60.4354 12.8532C59.7007 12.8807 58.9116 13.4312 58.3401 13.7614V20.4495H56.9524V11.9174H58.0408L58.2313 12.8257Z"
      fill="url(#microgaming-big-rule-5)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.7687 20.5872C69.2517 20.5872 69.4422 18.6055 69.4422 16.1835C69.4422 13.7615 69.2517 11.7798 65.7687 11.7798C62.2857 11.7798 62.0952 13.7615 62.0952 16.1835C62.0952 18.6055 62.2857 20.5872 65.7687 20.5872ZM65.7686 19.6514C63.5917 19.6514 63.4829 18.4954 63.4829 16.1835C63.4829 13.8441 63.5917 12.7156 65.7686 12.7156C67.9455 12.7156 68.0543 13.8441 68.0543 16.1835C68.0543 18.523 67.9455 19.6514 65.7686 19.6514Z"
      fill="url(#microgaming-big-rule-6)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.932 22.4863C73.17 22.4863 72.4898 22.4587 71.9728 22.4037L71.8367 23.2844C72.6258 23.3945 73.4422 23.4771 74.2585 23.4771C77.034 23.4771 77.7143 22.5413 77.7143 19.4863V11.945H76.6258L76.4898 12.7156C75.7551 12.2477 74.8299 11.7798 73.8231 11.7798C70.8571 11.7798 70.6938 13.5413 70.6938 16.1835C70.6938 18.8257 70.8843 20.5046 73.9592 20.4496C74.8571 20.422 75.7279 20.0092 76.3537 19.6514C76.3265 21.9083 76.0544 22.4863 73.932 22.4863ZM74.2584 12.7156C74.9931 12.7156 75.755 13.1009 76.3537 13.4863V18.7982C75.7822 19.1009 74.9931 19.5138 74.2584 19.5138C72.2176 19.5138 72.0815 18.4404 72.0815 16.1835C72.0815 13.8716 72.2176 12.7156 74.2584 12.7156Z"
      fill="url(#microgaming-big-rule-7)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.1157 19.6514L85.2518 20.4221H86.313V11.9175H85.2246L85.0885 12.6606C84.4082 12.2477 83.5103 11.7798 82.5035 11.7798C79.4559 11.7798 79.2926 13.4863 79.2926 16.1835C79.2926 18.8808 79.4831 20.6422 82.5579 20.5872C83.5375 20.5872 84.4354 20.0918 85.1157 19.6514ZM82.8845 12.7156C83.6192 12.7156 84.4083 13.1009 84.9797 13.4312V18.8808C84.3811 19.2386 83.6192 19.6514 82.8845 19.6514C80.8437 19.6514 80.7076 18.4954 80.7076 16.1835C80.7076 13.8716 80.8437 12.7156 82.8845 12.7156Z"
      fill="url(#microgaming-big-rule-8)"
    />
    <path
      d="M89.2517 12.6605C89.8776 12.2752 90.7211 11.8073 91.6191 11.7798C93.034 11.7248 93.7687 12.1101 94.1225 12.7156C94.7755 12.3027 95.6463 11.8073 96.5987 11.7798C99.483 11.6972 99.6735 13.1835 99.6735 15.2477V20.422H98.2857V15.3303C98.2857 13.5688 98.1769 12.7156 96.2993 12.7156C95.6191 12.7156 94.9116 13.1284 94.3402 13.4862C94.4762 14.0917 94.5306 14.7248 94.5034 15.3578V20.4495H93.3061V15.3303C93.3061 13.5688 93.1973 12.7156 91.3197 12.7156C90.6667 12.7156 89.9592 13.1284 89.415 13.4312V20.422H88.0272V11.9174H89.1157L89.2517 12.6605Z"
      fill="url(#microgaming-big-rule-9)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M101.388 9.41284V10.844H102.803V9.41284H101.388ZM101.415 11.9174V20.422H102.803V11.9174H101.415Z"
      fill="url(#microgaming-big-rule-10)"
    />
    <path
      d="M105.741 12.6606C106.422 12.2752 107.32 11.8074 108.299 11.7798C111.374 11.6973 111.564 13.1835 111.564 15.2477V20.422H110.177V15.3303C110.177 13.5688 110.041 12.7156 108 12.7156C107.265 12.7156 106.476 13.1285 105.905 13.4587V20.4496H104.517V11.9174H105.605L105.741 12.6606Z"
      fill="url(#microgaming-big-rule-11)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M116.218 22.4863C115.456 22.4863 114.776 22.4587 114.259 22.4037L114.123 23.2844C114.912 23.3945 115.728 23.4771 116.544 23.4771C119.32 23.4771 120 22.5413 120 19.4863V11.945H118.912L118.776 12.7156C118.041 12.2477 117.116 11.7798 116.109 11.7798C113.143 11.7798 112.98 13.5413 112.98 16.1835C112.98 18.8257 113.17 20.5046 116.245 20.4496C117.143 20.422 118.014 20.0092 118.64 19.6514C118.612 21.9083 118.34 22.4863 116.218 22.4863ZM116.517 12.7156C117.252 12.7156 118.014 13.1009 118.612 13.4863V18.7982C118.041 19.1009 117.252 19.5138 116.517 19.5138C114.476 19.5138 114.34 18.4404 114.34 16.1835C114.34 13.8716 114.476 12.7156 116.517 12.7156Z"
      fill="url(#microgaming-big-rule-12)"
    />
    <defs>
      <linearGradient
        id="microgaming-big-rule-1"
        x1="12.1438"
        y1="79.6215"
        x2="131.997"
        y2="50.9702"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E418" />
        <stop offset="0.3" stopColor="#31B6E9" />
        <stop offset="0.9757" stopColor="#21E418" />
      </linearGradient>
      <linearGradient
        id="microgaming-big-rule-2"
        x1="12.4719"
        y1="89.3456"
        x2="133.046"
        y2="64.2309"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E418" />
        <stop offset="0.3" stopColor="#31B6E9" />
        <stop offset="0.9757" stopColor="#21E418" />
      </linearGradient>
      <linearGradient
        id="microgaming-big-rule-3"
        x1="1.28258"
        y1="492.144"
        x2="121.126"
        y2="491.662"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E418" />
        <stop offset="0.3" stopColor="#31B6E9" />
        <stop offset="0.9757" stopColor="#21E418" />
      </linearGradient>
      <linearGradient
        id="microgaming-big-rule-4"
        x1="11.5438"
        y1="104.573"
        x2="132.899"
        y2="86.074"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E418" />
        <stop offset="0.3" stopColor="#31B6E9" />
        <stop offset="0.9757" stopColor="#21E418" />
      </linearGradient>
      <linearGradient
        id="microgaming-big-rule-5"
        x1="8.25511"
        y1="140.057"
        x2="129.459"
        y2="131.294"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E418" />
        <stop offset="0.3" stopColor="#31B6E9" />
        <stop offset="0.9757" stopColor="#21E418" />
      </linearGradient>
      <linearGradient
        id="microgaming-big-rule-6"
        x1="12.922"
        y1="103.785"
        x2="134.113"
        y2="83.2361"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E418" />
        <stop offset="0.3" stopColor="#31B6E9" />
        <stop offset="0.9757" stopColor="#21E418" />
      </linearGradient>
      <linearGradient
        id="microgaming-big-rule-7"
        x1="10.2943"
        y1="135.066"
        x2="131.648"
        y2="124.414"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E418" />
        <stop offset="0.3" stopColor="#31B6E9" />
        <stop offset="0.9757" stopColor="#21E418" />
      </linearGradient>
      <linearGradient
        id="microgaming-big-rule-8"
        x1="13.369"
        y1="111.287"
        x2="134.705"
        y2="92.5065"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E418" />
        <stop offset="0.3" stopColor="#31B6E9" />
        <stop offset="0.9757" stopColor="#21E418" />
      </linearGradient>
      <linearGradient
        id="microgaming-big-rule-9"
        x1="21.8768"
        y1="83.077"
        x2="132.987"
        y2="34.2794"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E418" />
        <stop offset="0.3" stopColor="#31B6E9" />
        <stop offset="0.9757" stopColor="#21E418" />
      </linearGradient>
      <linearGradient
        id="microgaming-big-rule-10"
        x1="4.33794"
        y1="504.969"
        x2="124.18"
        y2="504.486"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E418" />
        <stop offset="0.3" stopColor="#31B6E9" />
        <stop offset="0.9757" stopColor="#21E418" />
      </linearGradient>
      <linearGradient
        id="microgaming-big-rule-11"
        x1="14.9241"
        y1="115.422"
        x2="136.206"
        y2="95.9074"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E418" />
        <stop offset="0.3" stopColor="#31B6E9" />
        <stop offset="0.9757" stopColor="#21E418" />
      </linearGradient>
      <linearGradient
        id="microgaming-big-rule-12"
        x1="12.613"
        y1="144.801"
        x2="133.967"
        y2="134.149"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E418" />
        <stop offset="0.3" stopColor="#31B6E9" />
        <stop offset="0.9757" stopColor="#21E418" />
      </linearGradient>
    </defs>
  </svg>
);

IconProviderMicrogamingBig.propTypes = {
  className: PropTypes.string,
};
IconProviderMicrogamingBig.defaultProps = {
  className: null,
};
